// A number field holds whole numbers.
// It used to drop every non-digit, so "17,120.00" became 1712000.

/** The field's text as typed or pasted: digits and the first decimal point, with everything else dropped. */
export function numberText(v) {
  const s = String(v ?? '').replace(/[^\d.]/g, '');
  const [whole, ...rest] = s.split('.');
  return rest.length ? `${whole}.${rest.join('')}` : whole;
}

/** The whole number the field holds, or null when it holds none, such as "12.5", ".", or "abc". Text is read by its digits, so a fraction too small for a double is refused too. */
export function wholeNumber(v) {
  if (typeof v === 'number') return Number.isInteger(v) && v >= 0 ? v : null;
  const s = numberText(v);
  if (!/\d/.test(s)) return null;
  const [whole, fraction = ''] = s.split('.');
  if (/[1-9]/.test(fraction)) return null;
  const n = Number(whole || '0');
  return Number.isInteger(n) && n >= 0 ? n : null;
}
